import { ENGT_CHAT } from 'js/bot.model';
import { Modal } from 'ui/modal/modal.module';
import { AttachmentPreviewTemplate } from './attachmentPreview.template';
import { uploadFile } from './attachments.api';

export class AttachmentPreview {
	constructor(props) {
		this.initData();
		this.initWrapper();
		this.initEvents();
		this.initHelpers();
	}

	initData() {
		this.data = {};
		this.setter({
			placeholder: ENGT_CHAT.get('config.textAreaPlaceholder'),
		});
	}

	initWrapper() {
		this.attachmentPreview = document.createElement('div');
		this.attachmentPreview.innerHTML = AttachmentPreviewTemplate(this.data);
		this.attachmentPreview.className = 'engt-attachment-modal-content';
		this.modal = new Modal({
			wrapperId: 'replyAreaUpload',
			contentId: 'replyAreaUploadContent',
			content: this.attachmentPreview,
			contentCss: 'background-color: transparent',
		});

		this.html = this.modal.render();
	}

	initEvents() {
		const ref = this;
		this.attachmentInput = this.html.querySelector('#sendAttachmentInputBox');

		function onAttachmentTextInput(event) {
			const inputText = event.currentTarget.textContent?.trim?.();

			if (inputText) {
				ENGT_CHAT.get('onEnterPress')(() => {
					ref.showLoader();
					uploadFile.call(ref, inputText);
				});
			}
		}

		function onAttachmentSendClick() {
			const inputText = ref.attachmentInput?.innerText?.trim?.();
			ref.showLoader();
			uploadFile.call(ref, inputText);
		}

		this.attachmentInput.addEventListener('keydown', onAttachmentTextInput);
		this.html.querySelector('#sendAttachmentBtn').addEventListener('click', onAttachmentSendClick);
	}

	initHelpers() {
		ENGT_CHAT.set('showUploadBtn', this.showUploadBtn.bind(this));
		ENGT_CHAT.set('hideUploadBtn', this.hideUploadBtn.bind(this));
		ENGT_CHAT.set('openAttachmentsModal', this.openModal.bind(this));
	}

	showUploadBtn() {
		this.html.style.display = 'block';
	}

	hideUploadBtn() {
		this.html.style.display = 'none';
	}

	showLoader() {
		document.getElementById('replyAreaUploadContent').classList.add('engt-show-loader');
	}

	stopLoader() {
		document.getElementById('replyAreaUploadContent').classList.remove('engt-show-loader');
	}

	openModal() {
		this.modal.open();
	}

	closeModal() {
		this.attachmentInput.innerText = '';
		this.modal.close('', true);
		this.stopLoader();
		document.getElementById('engtChatFooter').style.transform = null;
	}

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	render() {
		return this.html;
	}
}
